import { useEffect, useState } from 'react';
import { getCurrentWorkspace } from '@/lib/api/workspaces';
import { supabase } from '@/integrations/supabase/client';

export function useWorkspace() {
  const [workspace, setWorkspace] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    async function loadWorkspace() {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
          setLoading(false);
          return;
        }

        const workspaceData = await getCurrentWorkspace(user.id);
        setWorkspace(workspaceData);
      } catch (err) {
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    }

    loadWorkspace();
  }, []);

  return { workspace, loading, error };
}
